import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companySiteApiClient } from '@src/api/company/site/companySiteApiClient';
import SpinnerOverlay from '@src/components/SpinnerOverlay';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// トップURL(/)取得(第二波)が失敗した際のリトライ設定
const MAX_RETRY = 5;
const RETRY_INTERVAL_MS = 3000;

function RedirectToCompanyTopPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;

    async function redirectToTopPage(attempt: number) {
      const res = await companySiteApiClient.topPageUrl();
      if (cancelled) {
        return;
      }
      handleApiResponse(
        res,
        (data) => {
          setLoading(false);
          navigate(data.url);
        },
        undefined,
        (response) => {
          // 第二波の失敗時に全画面Error500を描画すると、HTTP200のままエラー文言が
          // Googleにインデックスされ、検索結果に焼き付いてしまう(STAR-4367)。
          // errorStatusは立てず、サーバーエラー(exception)のときのみリトライで回復を待つ。
          // (404/429はリトライ対象外)。回復しない場合もローディング表示のままとし、
          // 第一波の正常なメタ情報を保持したまま、エラー文言をDOMに出さない。
          if (response.result === 'exception' && !cancelled && attempt < MAX_RETRY) {
            retryTimer = setTimeout(() => redirectToTopPage(attempt + 1), RETRY_INTERVAL_MS);
          }
        },
      );
    }

    redirectToTopPage(0);

    return () => {
      cancelled = true;
      if (retryTimer) {
        clearTimeout(retryTimer);
      }
    };
  }, [navigate]);

  return (
    <>
      <SpinnerOverlay loading={loading} />
    </>
  );
}

export default RedirectToCompanyTopPage;
